/* STADTHOLZ Design System — global animation + header behavior
   Requires GSAP 3.12 + ScrollTrigger (loaded via CDN in theme.liquid, deferred). */

(function () {
  var hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';

  if (hasGsap) {
    window.gsap.registerPlugin(window.ScrollTrigger);
  }

  function initReveals() {
    var selector = '.sz-reveal, .sz-reveal-left, .sz-reveal-right';

    if (!hasGsap) {
      // Fallback: IntersectionObserver toggles the CSS transition class.
      // A rAF-throttled catch-up sweep covers elements that jump through the
      // viewport between frames during fast (flick) scrolling — IO never
      // samples those, so without the sweep they would stay invisible.
      var pending = Array.prototype.slice.call(document.querySelectorAll(selector));

      var reveal = function (el) {
        el.classList.add('is-revealed');
        observer.unobserve(el);
        var i = pending.indexOf(el);
        if (i >= 0) pending.splice(i, 1);
        if (pending.length === 0) {
          window.removeEventListener('scroll', onScrollSweep);
        }
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) reveal(entry.target);
          });
        },
        { threshold: 0.1 }
      );

      var sweepQueued = false;
      var onScrollSweep = function () {
        if (sweepQueued) return;
        sweepQueued = true;
        requestAnimationFrame(function () {
          sweepQueued = false;
          for (var i = pending.length - 1; i >= 0; i -= 1) {
            // Everything at or above the current viewport bottom must be visible —
            // covers elements skipped by IO during fast scrolling, no matter how far.
            if (pending[i].getBoundingClientRect().top < window.innerHeight) {
              reveal(pending[i]);
            }
          }
        });
      };

      pending.forEach(function (el) {
        observer.observe(el);
      });
      window.addEventListener('scroll', onScrollSweep, { passive: true });
      return;
    }

    window.gsap.utils.toArray(selector).forEach(function (el) {
      window.gsap.to(el, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true,
        },
      });
    });
  }

  // Warenkorb-Feedback: nach "In den Warenkorb" (Konfigurator/Produktseite)
  // den Icon-Zaehler im Header per Section-Rendering-API aktualisieren.
  function initCartRefresh() {
    document.addEventListener('sz:cart:added', function (e) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?sections=cart-icon-bubble')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var el = document.getElementById('cart-icon-bubble');
          if (!el || !data['cart-icon-bubble']) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-icon-bubble'];
          var fresh = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.shopify-section') || tmp;
          document.querySelectorAll('#cart-icon-bubble, .sz-header__cart--menu').forEach(function (target) {
            target.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () { /* Anzeige-Update ist nice-to-have, nie blockierend */ });
      // Die Produktseite (sz-product.js, Ereignis mit variantId) hat ihren eigenen Weg zur Kasse
      // im Kaufblock; die Box gilt fuer den Konfigurator und alles ohne eigenen Block.
      if (!(e && e.detail && e.detail.variantId)) showCartConfirm(root);
    });
  }

  // Bestaetigung nach "In den Warenkorb" im Konfigurator (03.11.2026): mobil kamen nur 1 von 6
  // Warenkoerben bis zur Kasse, ausser dem Haekchen im Knopf gab es kein Feedback. Zeigt Artikel, Summe,
  // Abstand zum kostenlosen Versand und "Zur Kasse". Schwelle wie in der Ankuendigungsleiste.
  // Die Schwelle steht im Section-Setting "versandfrei_ab" und wird als Datenattribut
  // gerendert, damit Produktseite, Konfigurator und diese Box dieselbe Zahl nennen.
  // Der Rueckfall gilt nur fuer Seiten ohne das Attribut.
  var VERSANDFREI_AB_CENT = 8000;
  var confirmTimer = null;

  function versandfreiAbCent() {
    var traeger = document.querySelector('[data-versandfrei-ab-cents]');
    if (!traeger) return VERSANDFREI_AB_CENT;
    var wert = parseInt(traeger.getAttribute('data-versandfrei-ab-cents'), 10);
    return wert > 0 ? wert : VERSANDFREI_AB_CENT;
  }

  function euro(cent) {
    return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function closeCartConfirm() {
    var box = document.getElementById('sz-cart-confirm');
    if (box) box.classList.remove('is-open');
    document.body.classList.remove('sz-cart-confirm-offen');
    clearTimeout(confirmTimer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartConfirm();
  });

  function showCartConfirm(root) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        var box = document.getElementById('sz-cart-confirm');
        if (box) box.remove();
        box = el('div', 'sz-cart-confirm');
        box.id = 'sz-cart-confirm';
        box.setAttribute('role', 'status');
        box.setAttribute('aria-live', 'polite');

        var kopf = el('div', 'sz-cart-confirm__head');
        kopf.appendChild(el('span', 'sz-cart-confirm__title', '✓ Liegt im Warenkorb'));
        var zu = el('button', 'sz-cart-confirm__close', '×');
        zu.type = 'button';
        zu.setAttribute('aria-label', 'Hinweis schließen');
        zu.addEventListener('click', closeCartConfirm);
        kopf.appendChild(zu);
        box.appendChild(kopf);

        var artikel = cart.item_count === 1 ? '1 Artikel' : cart.item_count + ' Artikel';
        box.appendChild(el('p', 'sz-cart-confirm__sum', artikel + ' · Summe ' + euro(cart.total_price)));
        var rest = versandfreiAbCent() - cart.total_price;
        box.appendChild(el('p', 'sz-cart-confirm__ship',
          rest > 0 ? 'Noch ' + euro(rest) + ' bis zum kostenlosen Versand' : 'Der Versand ist kostenlos'));

        var aktionen = el('div', 'sz-cart-confirm__actions');
        var weiter = el('button', 'sz-btn sz-btn--secondary sz-btn--sm', 'Weiter einkaufen');
        weiter.type = 'button';
        weiter.addEventListener('click', closeCartConfirm);
        var kasse = el('a', 'sz-btn sz-btn--primary sz-btn--sm', 'Zur Kasse');
        kasse.href = root + 'checkout';
        aktionen.appendChild(weiter);
        aktionen.appendChild(kasse);
        box.appendChild(aktionen);

        document.body.appendChild(box);
        // Reflow erzwingen statt requestAnimationFrame: In einem Tab im Hintergrund laeuft
        // rAF nicht, die Box bliebe dann unsichtbar im Seitenkopf haengen und waere auch nach
        // der Rueckkehr nie zu sehen. Der Reflow startet den Uebergang zuverlaessig.
        void box.offsetWidth;
        box.classList.add('is-open');
        // Platz am Seitenende, damit die stehende Box nichts dauerhaft verdeckt.
        document.body.classList.add('sz-cart-confirm-offen');
        // Kein Selbstschliessen: Wer im Konfigurator Holz und Stoff vergleicht, braucht laenger
        // als neun Sekunden. Verschwindet die Box, ist der Weg zur Kasse wieder weg - genau der
        // Fehler, den sie beheben soll. Sie geht ueber das Kreuz, "Weiter einkaufen" und Escape zu.
        clearTimeout(confirmTimer);
      })
      .catch(function () { /* ohne Warenkorbdaten keine Bestaetigung */ });
  }

  function init() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      // Resting states already handled by CSS; just skip animation setup.
      document.querySelectorAll('.sz-reveal, .sz-reveal-left, .sz-reveal-right').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    } else {
      initReveals();
    }

    initCartRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
